module.exports = __webpack_public_path__ + "media/images/pc/stores/funabashi/access/chiba_funabashi_point4_2-2584e11bffcfbd0bc939434c311c65d5.jpg";